import { render, staticRenderFns } from "./ToldYou.vue?vue&type=template&id=f7bc2d46&"
import script from "./ToldYou.vue?vue&type=script&lang=js&"
export * from "./ToldYou.vue?vue&type=script&lang=js&"
import style0 from "./ToldYou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports